export default __webpack_public_path__ + "static/media/history_img_3.cf7cba19.png";